"use client";

import React from "react";

import Image from "next/image";
import DecorationLine from "@/components/global/ui/DecorationLine";
import DecorationSquares from "@/components/global/ui/DecorationSquares";
import Chip from "@/components/global/ui/Chip";
import NumberedIconList from "@/components/global/ui/NumberedIconList";
import YouTubeBanner from "@/components/global/youtube/YouTubeBanner";

import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";

import {PageCommunitySchema} from "@/sanity/pages/PageCommunityTemplate";

export default function YouTubeSection({
  data,
  className
}: {
  data: PageCommunitySchema;
  className?: string;
}) {

  return (
    <section
      id="YouTube"
      className={cn(
        "relative overflow-clip bg-[#0A1A1D] py-[13rem] lg:py-[20rem]",
        className
      )}
    >
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="left"
        style="light"
      />
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="right"
        style="light"
      />
      <DecorationSquares
        className="top-0"
        style="green"
      />

      <div className="container relative flex flex-col items-center">
        <Chip
          image={data?.youtubeChip?.icon}
          text={data?.youtubeChip?.text}
        />

        {data?.youtubeText && (
          <div className="richtext w-[min(70rem,100%)] prose-headings:text-white prose-p:text-white/70 mb-[3rem] lg:mb-[5rem]">
            <PortableText
              value={data.youtubeText}
              components={richTextComponent}
            />
          </div>
        )}

        <div className="w-[min(187.75rem,100%)] flex flex-col lg:flex-row items-center lg:justify-between gap-[3rem]">
          <div className="w-[min(88.375rem,100%)] relative">
            <Image
              className="!w-full lg:!h-[71.75rem] object-cover"
              src={data?.youtubeImage}
              alt=""
            />

            <YouTubeBanner
              language={data?.settings?.language || "de"}
              className="absolute left-[1rem] w-[calc(100%-2rem)] bottom-[1rem]"
            />
          </div>

          <NumberedIconList
            className="w-[min(88.375rem,100%)]"
            items={data?.youtubeItems}
          />
        </div>
      </div>
    </section>
  );
}
